import type { QueryClient } from "@tanstack/query-core";
import { DEFAULT_SESSION_QUERY_SCOPE_TOKEN } from "~/lib/query-keys";
import { getAppQueryClient } from "~/lib/ssr/runtime";
import { getBrowserPlatformApiClient } from "~/lib/trpc/browser-client";
import type { PlatformApiTrpcClient } from "~/lib/trpc/platform-api-adapter";
import type {
  AssetDomainDependencies,
  BrowserAssetDomainCollectionOptions,
} from "./collection-types";

export function getAssetDomainDependencies(
  options?: BrowserAssetDomainCollectionOptions & {
    platformApi?: PlatformApiTrpcClient;
    queryClient?: QueryClient;
  },
): AssetDomainDependencies {
  return {
    platformApi: options?.platformApi ?? getBrowserPlatformApiClient(),
    queryClient: options?.queryClient ?? getAppQueryClient(),
    sessionScopeToken:
      options?.sessionScopeToken ?? DEFAULT_SESSION_QUERY_SCOPE_TOKEN,
  };
}
